<style>
.mx-datepicker .mx-input-wrapper .mx-input {
  height: 34px;
  padding: 6px 12px;
  font-size: 14px;
  border: 1px solid #c9ccd7;
  font-family: "Calibri";
  line-height: 14px;
  font-weight: 300;
}

.mx-datepicker-main
  .mx-datepicker-body
  .mx-calendar-content
  .mx-table.mx-table-year {
  padding: 1px 1px;
}
</style>
<template>
  <section class="tables new-updated-design">
    <vue-snotify></vue-snotify>
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Member Focuses</h4>
          </div>
          <div class="card-body">
            <div class="panel-heading">
              <div class="row align-items-center">
                <div
                  class="col-xl-3 col-lg-5 col-md-5 col-sm-6 form-group"
                  style="font-size: 15px; font-weight: 300"
                >
                  <input
                    class="group"
                    v-model="serverParams.customFilters.status"
                    value="1"
                    type="radio"
                    @click="statusFilter('all')"
                  />
                  All
                  <input
                    class="group"
                    v-model="serverParams.customFilters.status"
                    value="2"
                    type="radio"
                    @click="statusFilter('PDC')"
                  />
                  PDC
                  <input
                    class="group"
                    v-model="serverParams.customFilters.status"
                    value="0"
                    type="radio"
                    @click="statusFilter('PCA')"
                  />
                  PCA
                  <input
                    class="group"
                    v-model="serverParams.customFilters.status"
                    value="11"
                    type="radio"
                    @click="statusFilter('CA')"
                  />
                  CA
                  <input
                    class="group"
                    v-model="serverParams.customFilters.status"
                    value="22"
                    type="radio"
                    @click="statusFilter('DC')"
                  />
                  DC
                </div>
                <div
                  class="col-xl-3 col-lg-4 col-md-4 col-sm-6 form-group"
                  style="font-size: 15px; font-weight: 300"
                >
                  <input
                    class="group"
                    v-model="serverParams.customFilters.memberStatus"
                    value="Active"
                    type="radio"
                    @click="memberStatusFilter('Active')"
                  />
                  Currents
                  <input
                    class="group"
                    v-model="serverParams.customFilters.memberStatus"
                    value="Inactive"
                    type="radio"
                    @click="memberStatusFilter('Inactive')"
                  />
                  Pasts
                  <input
                    class="group"
                    v-model="serverParams.customFilters.memberStatus"
                    value="Suspended"
                    type="radio"
                    @click="memberStatusFilter('Suspended')"
                  />
                  Futures
                </div>
                <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 form-group">
                  <input
                    class="form-control"
                    type="text"
                    name="search"
                    id="search"
                    placeholder="Search"
                    v-model="serverParams.customFilters.PracticeName"
                    @keyup="loadItems()"
                  />
                </div>
                <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 form-group">
                  <date-picker
                    v-model="serverParams.customFilters.year"
                    type="year"
                    :clearable="false"
                    @input="loadItems()"
                  ></date-picker>
                  <!-- <b-form-input id="MemberSince" type="date" v-model="serverParams.customFilters.year"  @change="loadItems()"></b-form-input> -->
                </div>
                <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 form-group">
                  <input
                    name="reset"
                    type="reset"
                    value="Reset"
                    class="btn btn-success btn-xs btn-rounded p-l-10 p-r-10"
                    @click="resetMemberData()"
                  />
                </div>
              </div>
            </div>
            <CircleLoader v-if="isLoading" />
            <vue-good-table
              mode="remote"
              :totalRows="totalRecords"
              :isLoading="isLoading"
              :pagination-options="{
                enabled: true,
                perPage: serverParams.perPage,
                perPageDropdown: [10, 20, 50, 100, 200],
              }"
              :sort-options="{
                enabled: true,
                initialSortBy: {
                  field: 'PracticeID',
                  type: 'desc',
                },
              }"
              :rows="rows"
              :columns="columns"
              @on-page-change="onPageChange"
              @on-per-page-change="onPerPageChange"
              @on-sort-change="onSortChange"
            >
              <template slot="table-row" slot-scope="props">
                <span
                  v-if="props.column.field === 'action'"
                  class="text-nowrap"
                >
                  <toggle-button
                    v-model="
                      spots.find((p) => p.spot_id === props.row.user.id)
                        .spot_status
                    "
                    @change="changeStatus(props.row.user.id, $event)"
                    :sync="true"
                    color="#070708"
                    class="mr-1"
                  />
                  <b-button
                    size="sm"
                    @click="editMember(props.row.id)"
                    class="mr-1 btn-info text-white"
                  >
                    Edit
                  </b-button>
                  <!-- <b-button size="sm"
                                            @click="deleteClientSpot(props.row.spot_id)"
                                            class="mr-1 btn-danger text-white">
                                    Delete
                                </b-button> -->
                </span>
              </template>
              <template slot="table-row" slot-scope="props">
                <span
                  v-if="props.column.field === 'user_view_m_focuses.Name'"
                  class="text-nowrap"
                >
                  <a
                    :href="'#'"
                    @click="userLogin(props.row.user_view_m_focuses.UserID)"
                  >
                    {{ props.row.user_view_m_focuses.Name }}
                  </a>
                </span>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>
    <div></div>
  </section>
</template>

<script>
import Vue from "vue";
import router from "../router";
import SortedTablePlugin from "vue-sorted-table";
import API from "@/api";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import CircleLoader from "@/pages/loaders/CircleLoader.vue";
Vue.use(SortedTablePlugin, {
  ascIcon: '<i class="ti-arrow-down"></i>',
  descIcon: '<i class="ti-arrow-up"></i>',
});
export default {
  name: "member_focusses",
  components: {
    DatePicker,
  },
  data() {
    return {
      isDisabled: false,
      selected: true,
      unSelected: false,
      serverParams: {
        customFilters: {
          PracticeName: "",
          memberStatus: "",
          status: null,
          year: "",
        },
        sort: [
          {
            field: "PracticeID", // example: 'name'
            type: "desc", // 'asc' or 'desc'
          },
        ],

        page: 1, // what page I want to show
        perPage: 10, // how many items I'm showing per page
      },
      columns: [
        {
          label: "PracticeName",
          field: "PracticeName",
          filterable: true,
        },
        {
          label: "PDC",
          field: "user_view_m_focuses.Name",
          sortable: true,
        },
        {
          label: "Status",
          field: "user_view_m_focuses.Status",
          sortable: true,
        },
        {
          label: "NP",
          field: "user_view_m_focuses.NP_Focus1Actual",
          sortable: true,
          formatFn: this.formatValue,
          // type: 'percentage',
        },
        {
          label: "ROF",
          field: "user_view_m_focuses.ROF_Focus2Actual",
          sortable: true,
          formatFn: this.formatValue,
          // type: 'percentage',
        },
        {
          label: "PV",
          field: "user_view_m_focuses.PV_Focus3Actual",
          sortable: true,
          formatFn: this.formatValue,
          // type: 'percentage',
        },
        {
          label: "CPR",
          field: "user_view_m_focuses.CPR_Focus4Actual",
          sortable: true,
          formatFn: this.formatValue,
          // type: 'percentage',
        },
        {
          label: "REV",
          field: "user_view_m_focuses.REV_Focus5Actual",
          sortable: true,
          formatFn: this.formatValue,
          // type: 'percentage',
        },
      ],
      isLoading: false,
      rows: [],
      totalRecords: 0,
      spots: [],
    };
  },
  methods: {
    addSpotter() {
      this.$router.push({ name: "addSpotter" });
    },
    editMember(e) {
      this.$router.push({ name: "edit_Member", params: { id: e } });
    },
    memberStatusFilter(value) {
      this.serverParams.customFilters.memberStatus = value;
      this.loadItems();
    },
    statusFilter(value) {
      this.serverParams.customFilters.status = value;
      this.loadItems();
    },
    resetMemberData() {
      this.serverParams.customFilters.memberStatus = "";
      this.serverParams.customFilters.status = null;
      this.serverParams.customFilters.PracticeName = "";
      this.serverParams.customFilters.year = "";

      this.loadItems();
    },
    loadItems() {
      this.isLoading = true;
      API.getAllMemberFocuses(
        this.serverParams,
        (data) => {
          this.totalRecords = data.totalRecords;
          this.rows = data.data.data;
          this.rows.forEach((q) => {
            const data = {};
            this.spots.push(data);
            // this.rows = data.data.data.user_view_m_focuses;

            // data.data.data.forEach(q => {
            //     if(q.user_view_m_focuses){
            //         const focusdata = {
            //             PracticeName: q.user_view_m_focuses.PracticeName,
            //             Name: q.user_view_m_focuses.Name,
            //             Status: q.user_view_m_focuses.Status,
            //             NP_Focus1Actual: q.user_view_m_focuses.NP_Focus1Actual,
            //             ROF_Focus2Actual: q.user_view_m_focuses.ROF_Focus2Actual,
            //             PV_Focus3Actual: q.user_view_m_focuses.PV_Focus3Actual,
            //             CPR_Focus4Actual: q.user_view_m_focuses.CPR_Focus4Actual,
            //             REV_Focus5Actual: q.user_view_m_focuses.REV_Focus5Actual
            //         }
            //         this.rows.push(focusdata);
            //     }

            // });
          });
          this.isLoading = false;
        },
        (err) => {
          this.isLoading = false;
        }
      );
    },
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("MMM dd, yyyy");
      }
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.loadItems();
    },
    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage });
      this.loadItems();
    },
    formatValue(value) {
      if (!isNaN(value) && value !== null) {
        const roundedPercentage = Math.round(value); // Remove decimal part
        return roundedPercentage + "%";
      } else {
        return "0%";
      }
    },
    onSortChange(params) {
      Vue.set(this.serverParams.sort, 0, {
        field: params[0].field,
        type: params[0].type,
      });
      this.loadItems();
    },
    onColumnFilter(params) {
      this.updateParams(params);
      this.loadItems();
      this.rows = "";
    },
    searchFn(params) {
      this.updateParams({ searchTerm: params });
      this.loadItems();
    },
    formatStatus(status) {
      if (status === "active") {
        return true;
      } else {
        return false;
      }
    },
    changeStatus(spot_id, event) {
      const data = {
        id: spot_id,
        status: event.value === true ? "active" : "Inactive",
      };
      API.updateMemberStatus(
        data,
        (data) => {
          if (data.status === 200) {
            this.$showNotification(data, "success");
          }
        },
        (err) => {}
      );
    },
    userLogin(id) {
    const params = { id: id }; 
    API.getUserDetails(params, 
      (resp) => {  
        const userDetails = resp.data;  
        const userId = userDetails.UserID; 
        const userPassword = userDetails.password; 
        this.performLogin(userId, userPassword);
      }, 
      (err) => {
        
        console.error("Error fetching user details:", err);
      }
    );
  },
  performLogin(id, password){
      API.userDirectLogin(
        { id: id },
        (token) => {
          console.log("User logged in successfully. Token:", token);

          if (
            token !== undefined &&
            token.data.user !== null &&
            token.data.user.token !== ""
          ) {
            let userDetails = {
              userID: token.data.user.UserID,
              Username: token.data.user.Username,
              FirstName: token.data.user.FirstName,
              LastName: token.data.user.LastName,
              email: token.data.user.email,
              PracticeID: token.data.user.PracticeID,
              PracticeName: token.data.user.PracticeName,
              Status: token.data.user.Status,
              MemberStatus: token.data.user.pdc_membershipstatus,
              serviceId: token.data.user.MembershipServiceID,
              password: password,
            };

            localStorage.setItem("userLoginToken", token.data.token);
            localStorage.setItem("userDetails", JSON.stringify(userDetails));
            window.open(
              router.resolve({ name: "user_dashboard" }).href,
              "_blank"
            );
          }
        },
        (err) => {
          console.error("Error logging in:", err);
        }
      );
    },
  },
  computed: {},
  mounted() {
    this.loadItems();
  },
};
</script>